import Decimal from 'decimal.js';

// TODO: LOGIC-ERROR - The function uses toDecimalPlaces(0, Decimal.ROUND_DOWN) which rounds values between 0 and 1 down to 0,
// making isPositive(0.5) return false when it should logically return true. This rounding behavior appears intentional
// but contradicts the function name. Fixing this bug might be a breaking change - any code that relies on this function
// expecting values < 1 to be considered "not positive" might need to move that logic outside of this function.
export function isPositive(value: Decimal): boolean {
    return value.toDecimalPlaces(0, Decimal.ROUND_DOWN).gt(new Decimal(0));
}
